import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useMediaQuery, useTheme } from '@material-ui/core';

import Conditional from '../conditional';
import { CustomKanbanColumnEmpty } from '../custom-kanban-column-empty';

import useStyles from './CustomKanbanColumn.styles';

export function CustomKanbanColumn(props) {
  const {
    classes = {},
    children = '',
    Chip = null,
    count,
    showEmpty = true,
    emptyText,
    title,
  } = props;

  const componentClasses = useStyles();

  const theme = useTheme();

  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const showChip = !isMdUp && !!Chip;

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div className={classNames(componentClasses.column, classes.column)}>
        <Conditional if={isMdUp}>
          <div className={componentClasses.header}>
            <div className={componentClasses.title}>{title}</div>
            <div className={componentClasses.badge}>{count}</div>
          </div>
        </Conditional>
        <div className={componentClasses.body}>
          {showChip && (
            <div
              className={classNames(
                componentClasses.chipContainer,
                classes.chipContainer,
              )}
            >
              {Chip}
            </div>
          )}
          <CSSTransition
            in={!showEmpty}
            timeout={500}
            unmountOnExit
            classNames={{
              exit: 'animated bounce',
              exitActive: 'animated bounce',
              exitDone: 'animated bounce',
            }}
          >
            <div className={componentClasses.childrenContainer}>{children}</div>
          </CSSTransition>
          <CSSTransition
            in={showEmpty}
            timeout={{ appear: 0, enter: 1000, exit: 0 }}
            unmountOnExit
            classNames={{
              appear: 'animated fadeIn',
              appearActive: 'animated fadeIn',
              appearDone: 'animated fadeIn',
              enter: 'animated fadeIn',
              enterActive: 'animated fadeIn',
              enterDone: 'animated fadeIn',
            }}
          >
            <CustomKanbanColumnEmpty text={emptyText} />
          </CSSTransition>
        </div>
      </div>
    </div>
  );
}
